import React, { useCallback } from 'react';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { editLog, openLogEdition, closeLogEdition, resolveLog } from 'redux/modules/log/effects';
import { isLogEditableAfterCreation } from 'redux/modules/log/selectors';

import ReadMode from './modes/ReadMode';
import CreateMode from './modes/CreateMode';
import EditMode from './modes/EditMode';
import EditModeExtended from './modes/EditModeExtended';

const LogItem = (props) => {
  const {
    id,
    shipperOrderId,
    shipper_order_id,
    journey_id,
    closeLogEdition,
    openLogEdition,
    UIEditMode,
    editLog,
    resolveLog,
    createMode,
    extendedModeEdit,
  } = props;

  const handleEdition = useCallback(
    (log) => {
      editLog(log);
    },
    [editLog]
  );

  const handleCommentClick = useCallback(() => {
    openLogEdition(id);
  }, [id, openLogEdition]);

  const handleCancelClick = useCallback(() => {
    closeLogEdition(id);
  }, [id, closeLogEdition]);

  const handleResolveClick = useCallback(
    (log) => {
      resolveLog({ shipperOrderId: shipper_order_id, journeyId: journey_id, id });
    },
    [resolveLog, shipper_order_id, journey_id, id]
  );

  if (createMode) {
    return <CreateMode shipper_order_id={shipperOrderId} {...props} />;
  }

  if (!!UIEditMode && UIEditMode === 'normal') {
    return <EditMode onSubmit={handleEdition} onCancel={handleCancelClick} {...props} />;
  }

  if (extendedModeEdit) {
    return <EditModeExtended onSubmit={handleEdition} {...props} />;
  }

  return (
    <ReadMode onCommentClick={handleCommentClick} onResolveClick={handleResolveClick} {...props} />
  );
};

const enhance = compose(
  injectIntl,
  connect(
    (state, props) => ({
      extendedModeEdit: isLogEditableAfterCreation(state, props.id),
    }),
    {
      editLog,
      openLogEdition,
      closeLogEdition,
      resolveLog,
    }
  )
);

export default enhance(LogItem);
